import React, { SFC } from 'react'
import ActionData from '../../../types/ActionData'
import User from '../../../types/UserList'
import Select from 'react-select'
import { InputGroup, Button, Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CircularProgress from '@material-ui/core/CircularProgress'
import UserRow from '../UserRow'
import './index.css'

type Props = {
  filterUsers: string
  height: number
  sortUsers: string
	users: Array<User>
	usersResult: ActionData
  onChangeFilter: (e: any) => void
  onChangeSort: (selected: any) => void
  onOpenUserModal: (type:string,e: any,user?:User) => void
	onSendEmail: (e: any, user: User) => void
}

const AllUsers: SFC<Props> = (props) => {
  const { filterUsers, height, sortUsers, users, usersResult, onChangeFilter, onChangeSort, onOpenUserModal, onSendEmail } = props
  const sortOptions = [
	  {value: 'a-z', label: 'Sort by A - Z'},
	  {value: 'z-a', label: 'Sort by Z - A'}
	]
  
  return (
    <div className="all-users-container">
			<div className="all-users-filter-and-sort">
				<InputGroup className="mb-3 all-users-filter">
					<InputGroup.Append>
						<Button variant="outline-secondary"><FontAwesomeIcon icon={['fas', 'filter']} /></Button>
					</InputGroup.Append>
					<Form.Control type="text" placeholder="filter" onChange={onChangeFilter}/>
				</InputGroup>
				<Form.Group controlId="memberForm.sortSelect" className="all-users-sort">
					<Select
						placeholder="Choose an option"
						options={sortOptions}
						value={sortOptions.find((sortType: any)=>sortType.value===sortUsers)}
						onChange={onChangeSort}
					/>
				</Form.Group> 
			</div>
			<div style={{height:height-334, overflow:'auto'}}>
				{
					usersResult.loading === true ? (
						<div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px'}}>
							<CircularProgress size={40} />
							<span style={{marginTop:'20px'}}>Loading data</span>
						</div> 
					) : (
						users
						.filter(
							user => (user.first_name.toLowerCase()+' '+user.last_name.toLowerCase()).indexOf(filterUsers.toLowerCase())!==-1
						)
						.sort((a, b) => {
							return (a.first_name+' '+a.last_name < b.first_name+' '+b.last_name ? -1: 1 ) * (sortUsers === 'a-z' ? 1 : -1);
						})
						.map((user) => 
							<UserRow
								enabled={user.enabled}
								first_name={user.first_name}
								key={user.user_id} 
								last_name={user.last_name}
								provider_data={user.provider_data}
								role={user.role}
								role_id={user.role_id}
								status={user.status}
								user_id={user.user_id}
								openEditUserModal={(e: any)=>{onOpenUserModal('edit', e, user)}}
								onSendEmail={(e:any)=>{onSendEmail(e, user)}}
							/>
						)
					)
				}
			</div>
		</div>
  )
}
export default AllUsers
